import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { IUserPreferences } from 'models/user/userpreferences';
import { Articles } from '../Article/Articles';
import { IArticlesData } from 'models/magazine/article/articles';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	userPreferences?: IUserPreferences;
	articlesData?: IArticlesData;
	selectedTab?: string;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		userPreferences: state.userPreferences,
		articlesData: state.articles,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ListingList extends React.Component<IProps> {
	constructor(props) {
		super(props);
	}

	render() {
		const { t, selectedTab } = this.props;

		const emptyResults: JSX.Element = (
			<div className="noResult">
				{renderIcon('missing', 25)}
				<p className="p18">{t('User_UserCard_NothingHereYet')}</p>
				<p className="p14">{t('User_UserCard_UserHasNoListings')}</p>
			</div>
		);

		return (
			<>
				<Articles selectedTab={selectedTab} />
				{this.props.articlesData?.items.length > 0 ? null : emptyResults}
			</>
		);
	}
}

export default ListingList;
